// https:// + domain segments (alphanumeric, hyphens) + TLD (min 2 alpha) + optional port + optional path
const HTTPS_URL_PATTERN =
  /^https:\/\/([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/[^\s]*)?$/;

export const CallbackUrlValidators = {
  url: (v) => {
    if (!v?.trim()) return "Callback URL is required";
    if (v.trim().length > 100) return "URL must not exceed 100 characters";
    if (!v.trim().startsWith("https://")) return "URL must use HTTPS";
    if (!HTTPS_URL_PATTERN.test(v.trim()))
      return "Enter a valid URL (e.g. https://example.com/webhook)";
    return null;
  },
};
